module.exports = __webpack_public_path__ + "static/2.a7268fe9.png";


//////////////////
// WEBPACK FOOTER
// D:/Workarea/iota.org/documentation/src/assets/2.png
// module id = 215
// module chunks = 1